import { render } from "./LoadingTable.vue?vue&type=template&id=0f274892"
import script from "./LoadingTable.vue?vue&type=script&lang=js"
export * from "./LoadingTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__